import { CALL_API } from "../api.middleware";
import {
  STORE_FATCA_DETAILS,
  STORE_NOMINEE_DETAILS,
  STORE_INVESTMENT_DETAILS,
  STORE_SCHEME_DETAILS,
  STORE_APPLICANT_PARAMS,
  STORE_INVESTMENT_PARAMS,
  STORE_SCHEME_PARAMS,
  STORE_ADDRESS_SUCESS,
  GET_NOMINEE_DETAILS,
  GET_NOMINEE_DETAILS_SUCESS,
  GET_NOMINEE_DEATILS_FAILED,
  GET_BANK_DETAILS,
  GET_BANK_DETAILS_SUCESS,
  GET_BANK_DETAILS_FAILED,
  STORE_PAN,
  CLEARING_FIRST_TIME_INVETOR_JOURNEY_SUCCESS,
} from "../types";

export const getBankList = () => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/Ktrack_GetBanks",
        method: "GET",
      },
    });
  } catch (error) {
    console.log({ error });
  }
};

export const validatePennyDrop = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/ValidatePennyDrop",
        method: "GET",
        params,
      },
    });
  } catch (error) {
    console.log({ error });
  }
};
export const getRelationShipList = () => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/getmasternewpur",
        method: "GET",
        params: {
          opt: "nrn",
        },
      },
    });
  } catch (error) {
    console.log({ error });
  }
};
export const getNomineeDetails = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/ktrack_GetDIT_NomineeDetails",
        params,
        types: [
          GET_NOMINEE_DETAILS,
          GET_NOMINEE_DETAILS_SUCESS,
          GET_NOMINEE_DEATILS_FAILED,
        ],
        method: "GET",
      },
    });
  } catch (error) {
    console.error(error);
  }
};
export const NewinvestorBankDetails = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/ktrack_GetDIT_BankDetails",
        params,
        method: "GET",
        types: [
          GET_BANK_DETAILS,
          GET_BANK_DETAILS_SUCESS,
          GET_BANK_DETAILS_FAILED,
        ],
      },
    });
  } catch (error) {
    console.error(error);
  }
};
export const getNav = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/getNavData",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    console.error(error);
  }
};
export const getStatesList = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/Ktrack_GetStates",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getTinIdentificationList = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GetTINIdentityTypes",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getTinCountries = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/TINcountryList",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const validateTINNumber = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/ValidateTIN",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCountriesList = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/Ktrack_GetCountries",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const getBankDetails = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        params,
        url: "/getBankdetailsByIFSC",
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};
export const getCitiesList = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/Ktrack_Getcitybtstate",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    console.error(error);
  }
};

export const submitSipDetails = (body) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/new_investor_sip_submit",
        body,
        method: "POST",
        showLoader: true,
      },
    });
  } catch (error) {
    console.error(error);
  }
};

export const submitLumpsumDetails = (body) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/new_investor_lumpsum_submit",
        body,
        method: "POST",
        showLoader: true,
      },
    });
  } catch (error) {
    console.error(error);
  }
};
export const getAccountTypes = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GetMasterNewpur_All",
        params,
        method: "GET",
        showLoader: true,
      },
    });
  } catch (error) {
    console.error(error);
  }
};

export const getKycDetails = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/Ktrack_GetKYCaddress",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    console.error(error);
  }
};
export const bankAccountTypes = () => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/ktrack_Dist_Getbankaccounttypes",
        method: "GET",
        showLoader: true,
      },
    });
  } catch (error) {
    console.error(error);
  }
};

export const storeFatcaDetails = (body) => {
  return {
    type: STORE_FATCA_DETAILS,
    body,
  };
};
export const storeNomineeDetails = (body) => {
  return {
    type: STORE_NOMINEE_DETAILS,
    body,
  };
};
export const storeInvestmentDetails = (body) => {
  return {
    type: STORE_INVESTMENT_DETAILS,
    body,
  };
};

export const storeSchemeDetails = (body) => {
  return {
    type: STORE_SCHEME_DETAILS,
    body,
  };
};

export const storeSchemeParams = (body) => {
  return {
    type: STORE_SCHEME_PARAMS,
    body,
  };
};

export const storeApplicantParams = (body) => {
  return {
    type: STORE_APPLICANT_PARAMS,
    body,
  };
};

export const storeInvestmentParams = (body) => {
  return {
    type: STORE_INVESTMENT_PARAMS,
    body,
  };
};
export const storeAddress = (body) => {
  return {
    type: STORE_ADDRESS_SUCESS,
    body,
  };
};
export const storePan = (body) => {
  return {
    type: STORE_PAN,
    body,
  };
};
export const clearingFirstTimeInvestorJourney = (body) => {
  return {
    type: CLEARING_FIRST_TIME_INVETOR_JOURNEY_SUCCESS,
    body,
  };
};